import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold tracking-wider uppercase text-primary-700 bg-primary-100 px-3 py-1 rounded-full mb-4">
            Browse Products
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Discover products across all categories available through Basetao. Click any category to start browsing on the main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="h-32 overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex items-center gap-2 p-3">
                <div className="w-7 h-7 rounded-md bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} w-3.5 h-3.5 flex items-center justify-center text-accent-700`}></i>
                </div>
                <span className="text-xs font-medium text-foreground-800 leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}